import { useEffect, useMemo, useState } from 'react'

import { useFetchImageStyles } from '../../../hooks/apiHooks/twinHooks'
import { useTwinPreview } from '../../../hooks/storeHooks/useTwin'

export const useStyle = () => {
  const { selectedImageStyle, setSelectedImageStyle } = useTwinPreview()

  const [genders, setGenders] = useState<string[]>([])
  const [categories, setCategories] = useState<string[]>([])
  const [selectedGender, setSelectedGender] = useState<string | null>(null)
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)

  const { data: imageStyles } = useFetchImageStyles()

  useEffect(() => {
    if (!imageStyles?.data?.length) return
    const uniqGenders = Array.from(
      new Set(imageStyles.data.map(s => s?.gender).filter(Boolean)),
    )
    setSelectedGender(uniqGenders[0])

    const uniqCategories = Array.from(
      new Set(imageStyles.data.map(s => s?.category).filter(Boolean)),
    )

    setSelectedCategory(uniqCategories[0])

    setGenders(uniqGenders)
    setCategories(uniqCategories)
  }, [imageStyles])

  const handleGenderChange = (gender: string) => {
    setSelectedGender(gender)
  }

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category)
  }

  const handleImageStyleChange = (imageStyle: string) => {
    setSelectedImageStyle(imageStyle)
  }

  const filteredImageStyles = useMemo(() => {
    if (!imageStyles?.data?.length) return []
    return imageStyles.data.filter(
      s => s.gender === selectedGender && s.category === selectedCategory,
    )
  }, [imageStyles, selectedGender, selectedCategory])

  return {
    genders,
    categories,
    selectedGender,
    selectedCategory,
    selectedImageStyle,
    filteredImageStyles,
    handleGenderChange,
    handleCategoryChange,
    handleImageStyleChange,
  }
}
